import {
    SYNC_GUEST_CARD_FAILURE,
    SYNC_GUEST_CARD_REQUEST,
    SYNC_GUEST_CARD_SUCCESS,
    CLEAR_SYNC_GUEST_CARD_MESSAGE,
} from '../constants/syncGuestCard';

const initialState = {
    loading: false,
    data: [],
    errMsg: '',
};

export const syncGuestCardReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SYNC_GUEST_CARD_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
                errMsg: '',
            };
        case SYNC_GUEST_CARD_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case SYNC_GUEST_CARD_FAILURE:
            return {
                ...state,
                loading: false,
                errMsg: action.payload,
            };
        case CLEAR_SYNC_GUEST_CARD_MESSAGE:
            return {
                ...state,
                data: [],
                errMsg: '',
            };
        default:
            return state;
    }
};
